/**
 * merge : merging two an array
 *
 * @author Nitesh <nitesh.meena@biz2credit.com>
 *
 * @param leftArr array
 * @param rightArr array
 * @param key string
 */
const merge = (leftArr, rightArr, key = null) => {
    let sortedArr = [], leftDiff, rightDiff;
    while (leftArr.length && rightArr.length) {
        if (typeof leftArr[0] === 'object' && key !== null) {
            const num1 = leftArr[0][key].replace(/[,$]/gm, ""), num2 = rightArr[0][key].replace(/[,$]/gm, "");
            leftDiff = isNaN(num1) ? initScript.hashCode(num1) : +num1;
            rightDiff = isNaN(num2) ? initScript.hashCode(num2) : +num2;
        }
        else if (typeof leftArr[0] === 'object') {
            let leftSplit = (typeof leftArr[0].value === 'string') ?  leftArr[0].value.split('-') : [];
            let rightSplit = (typeof rightArr[0].value === 'string') ?  rightArr[0].value.split('-') : [];
            leftDiff = (leftSplit.length > 1) ? Math.abs(Number(leftSplit[0]) - Number(leftSplit[1])) : leftArr[0].value;
            rightDiff = (rightSplit.length > 1) ? Math.abs(Number(rightSplit[0]) - Number(rightSplit[1])) : leftArr[0].value;
        } else {
            leftDiff = leftArr[0].toString().trim().toLowerCase();
            rightDiff = rightArr[0].toString().trim().toLowerCase();
        }

        if (leftDiff < rightDiff) {
            sortedArr.push(leftArr[0]);
            leftArr = leftArr.slice(1)
        } else {
            sortedArr.push(rightArr[0]);
            rightArr = rightArr.slice(1)
        }
    }
    while (leftArr.length)
        sortedArr.push(leftArr.shift());
    while (rightArr.length)
        sortedArr.push(rightArr.shift());
    return sortedArr;
};

/**
 * mergeSort : sorting an array
 *
 * @author Nitesh <nitesh.meena@biz2credit.com>
 *
 * @param input array
 * @param key string
 */
const mergeSort = (input, key = null) => {
    if (input.length < 2) {
        return input; }
    else {
        const midpoint = parseInt(input.length / 2);
        const leftArr   = input.slice(0, midpoint);
        const rightArr  = input.slice(midpoint, input.length);
        return merge(mergeSort(leftArr, key), mergeSort(rightArr, key), key);
    }
};
